/*
 * Dhrohar tabs (0.3.0): WAI-ARIA tabs for the homepage product edit.
 * Click or Enter/Space selects; Left/Right/Home/End move between tabs (automatic activation).
 * Panels other than the selected one keep the `hidden` attribute, so their lazy images load only when shown.
 */
if (!customElements.get('dhrohar-tabs')) {
  class DhroharTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length < 2) return;
      this.onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.tabs.includes(tab)) this.select(tab, false);
      };
      this.onKeydown = (event) => {
        const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
        if (index === -1) return;
        const last = this.tabs.length - 1;
        const next = { ArrowRight: index === last ? 0 : index + 1, ArrowLeft: index === 0 ? last : index - 1, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next], true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.onBlockSelect = (event) => {
        const tab = this.tabs.find((item) => item === event.target || item.contains(event.target));
        if (tab) this.select(tab, false);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      // Exactly one tab is always selected (the markup marks the first usable one; this guards any other state).
      const current = this.tabs.find((item) => item.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.select(current, false);
    }

    disconnectedCallback() {
      if (!this.onClick) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(tab, moveFocus) {
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (moveFocus) tab.focus();
    }
  }

  customElements.define('dhrohar-tabs', DhroharTabs);
}
